import type { Category } from "@/services/collection/categories";
import type { CatalogueFilter } from "@/services/collectibles/collectiblesFilter";
import { defineStore } from "pinia";

type CatalogueFilterStoreState = {
  filters: CatalogueFilter[];
};

export const useCatalogueFilterStore = defineStore("catalogueFilter", {
  state: () =>
    ({
      filters: [],
    }) as CatalogueFilterStoreState,

  actions: {
    save(filter: CatalogueFilter) {
      const categoryId = filter.category.id;
      const categoryFilterExists = this.filters.find((foundFilter) => foundFilter.category.id === categoryId);
      if (!categoryFilterExists) {
        this.filters.push(filter);
      }
    },
    getForCategory(category: Category): CatalogueFilter | undefined {
      return this.filters.find((foundFilter) => foundFilter.category.id === category.id) as CatalogueFilter | undefined;
    },
  },
});
